<template>
  <aside id="top">
    <p v-if="student" @click="showLogout = !showLogout">{{ student.name }} @ <b>{{ room }}</b>
        <a href="#" class="logout" v-if="showLogout" @click="logout">Log out</a>
    </p>
  </aside>
</template>

<script>
export default {
    name: 'Top',
    data(){
        return {
            showLogout: false
        }
    },
    methods: {
        toggleInfo(){
            this.$store.commit('toggleInfo');
        },
        logout(){
            this.$store.dispatch('logout', this.$route.params.room);
        }
    },
    computed: {
        room(){
            return this.$route.params.room;
        },
        student(){
            return this.$store.getters.student;
        }
    }
}
</script>

<style lang="scss">
@import './../scss/variables';

#top {
    padding: 1rem;
    display: flex;
    align-items: center;
    position: fixed;

    p {
        &:hover {
            cursor: pointer;
        }
    }
    a {
        position: absolute;

        &.logout {
            bottom: -2rem;
            left: 50%;
            margin: 0 0 0 -3rem;
            background: $darkGrey;
            display: flex;
            width: 4rem;
            padding: .5rem 1rem;
            border-radius: $innerRadius;
            color: $lightGrey;
            text-decoration: none;
            box-shadow: 0 0 2rem rgba(0, 0, 0, .3);

            &:after {
                bottom: 100%;
                left: 50%;
                border: solid transparent;
                content: "";
                height: 0;
                width: 0;
                position: absolute;
                pointer-events: none;
                border-color: rgba(0, 0, 0, 0);
                border-bottom-color: $darkGrey;
                border-width: 6px;
                margin-left: -6px;
            }

            &:hover {
                color: $red;
            }
        }
    }

    > img {
        width: 2rem;
        margin: 0 1rem 0 .5rem;
    }

    p {
        margin: 0 .25rem;
        padding: 0;

        &.room {
            font-size: 1.2rem;
            padding: .125rem .5rem;
            border-radius: $innerRadius;
            font-weight: 500;
            letter-spacing: .125rem;
            border: .125rem solid $darkGrey;

            &:hover {
                cursor: pointer;
            }
        }
    }
}
</style>